module.exports = __webpack_public_path__ + "static/media/commande.077cef2e.png";